import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type ColorLabel = {
  id: string
  name: string
  color: string
  contactAccountIds: string[]
}

const fetchColorLabels = async ({ pageParam = '0', q }: FetchParams): Promise<PaginatedResponse<ColorLabel>> => {
  // URLSearchParams encodes the typed text: "R&D" or "#sport" pasted as is
  // would cut the address at the "&" or the "#".
  const params = new URLSearchParams()
  params.append('page', pageParam)
  if (q) {
    params.append('q', q)
  }
  const url = `/color-labels?${params.toString()}`
  const { data } = await api.get<PaginatedResponse<ColorLabel>>(url)
  return data
}

export const usePaginateColorLabels = (q?: string) => {
  return usePaginate<ColorLabel>('color-labels', fetchColorLabels, { q })
}

